<template>
    <div class="message-wrap">

    </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "message-wrap",
    data() {
      return {}
    },
  }
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/home/mine/message/index.vue